import { createService } from '@/services/serviceFactory';
import type { 
  Voucher, 
  CreateVoucherInput, 
  UpdateVoucherInput, 
  VoucherFilters, 
  VoucherListResponse, 
  VoucherStats,
  BulkVoucherAction,
  BulkVoucherResponse,
  VoucherExportOptions
} from './vouchers.interfaces';

export interface IVouchersService {
  getVouchers(page: number, pageSize: number, filters?: VoucherFilters): Promise<VoucherListResponse>;
  getVoucherById(id: string): Promise<Voucher>;
  createVoucher(data: CreateVoucherInput): Promise<Voucher>;
  updateVoucher(id: string, data: UpdateVoucherInput): Promise<Voucher>;
  deleteVoucher(id: string): Promise<void>;
  activateVoucher(id: string): Promise<Voucher>;
  deactivateVoucher(id: string): Promise<Voucher>;
  extendVoucherValidity(id: string, newValidUntil: string): Promise<Voucher>;
  getVoucherStats(id: string): Promise<VoucherStats>;
  
  // Ações em lote
  bulkAction(action: BulkVoucherAction): Promise<BulkVoucherResponse>;
  bulkActivateVouchers(ids: string[]): Promise<BulkVoucherResponse>;
  bulkDeactivateVouchers(ids: string[]): Promise<BulkVoucherResponse>;
  bulkDeleteVouchers(ids: string[]): Promise<BulkVoucherResponse>;
  bulkExtendValidity(ids: string[], newValidUntil: string): Promise<BulkVoucherResponse>;
  
  // Exportação
  exportVouchers(options: VoucherExportOptions, filters?: VoucherFilters, selectedIds?: string[]): Promise<Blob>;
}

// Import classes (will be implemented next)
import { VouchersApiService } from './vouchers.api';
import { VouchersMockService } from './vouchers.mock';

export const createVouchersService = (): IVouchersService => {
  return createService<IVouchersService>(
    'vouchers',
    VouchersApiService,
    VouchersMockService
  );
};